module.exports = __webpack_public_path__ + "static/img/gamelist24.688ea34a.png";